/**
 * Sekmeler arası oturum paylaşımı + girişten sonra hedefe dönüş (22.10.2026).
 *
 * Oturum `sessionStorage`'dadır (sekmeye özel). Mail'deki "VERTEX'te aç" bağlantısı YENİ sekmede
 * açılır → o sekmede oturum yoktur ve kullanıcı açık bir VERTEX sekmesi olduğu hâlde giriş ekranına
 * düşerdi. Çözüm: oturumsuz açılan sekme aynı kökenden (origin) açık sekmelere BroadcastChannel ile
 * sorar; oturumu olan sekme kendi kaydını verir. Tarayıcının tüm VERTEX sekmeleri kapanınca oturum
 * yine kaybolur (sessionStorage davranışı korunur) — kalıcı oturum AÇILMADI.
 * Kanal yalnız aynı origin'e açıktır; başka site bu mesajları göremez.
 */
const CHANNEL = 'vertex-auth'
const AUTH_KEY = 'auth_state'
const COMPANY_KEY = 'app_activeCompany'
const RETURN_KEY = 'vertex.returnTo'

let channel = null
function ch() {
  if (channel) return channel
  try {
    channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(CHANNEL) : null
  } catch {
    channel = null
  }
  return channel
}

/** Oturumu olan sekme: başka sekmeden gelen isteğe kendi oturum kaydıyla cevap verir. */
export function startAuthShareResponder() {
  const c = ch()
  if (!c) return
  c.addEventListener('message', (ev) => {
    if (ev?.data?.type !== 'request') return
    try {
      const auth = sessionStorage.getItem(AUTH_KEY)
      if (!auth) return
      c.postMessage({ type: 'state', id: ev.data.id, auth, company: sessionStorage.getItem(COMPANY_KEY) })
    } catch { /* depolama kapalı — sessiz */ }
  })
}

/**
 * Oturumsuz açılan sekme: açık sekmelerden oturum ister. Cevap gelirse sessionStorage'a yazar ve
 * true döner (çağıran store'ları yeniden başlatır). En çok `timeoutMs` bekler.
 */
export function adoptAuthFromOtherTabs(timeoutMs = 350) {
  return new Promise((resolve) => {
    let has = false
    try { has = !!sessionStorage.getItem(AUTH_KEY) } catch { /* yok */ }
    const c = ch()
    if (has || !c) { resolve(false); return }
    const id = Math.random().toString(36).slice(2)
    const done = (ok) => { c.removeEventListener('message', onMsg); clearTimeout(t); resolve(ok) }
    const onMsg = (ev) => {
      const d = ev?.data
      if (d?.type !== 'state' || d.id !== id || !d.auth) return
      try {
        sessionStorage.setItem(AUTH_KEY, d.auth)
        if (d.company && !sessionStorage.getItem(COMPANY_KEY)) sessionStorage.setItem(COMPANY_KEY, d.company)
        done(true)
      } catch { done(false) }
    }
    c.addEventListener('message', onMsg)
    const t = setTimeout(() => done(false), timeoutMs)
    c.postMessage({ type: 'request', id })
  })
}

/** Oturumsuz gelinen adres — girişten sonra oraya dönülür (giriş/kök sayfası hariç). */
export function rememberReturnTo(path) {
  try {
    if (!path || path === '/' || path.startsWith('/login') || path.startsWith('/partner/login')) return
    sessionStorage.setItem(RETURN_KEY, path)
  } catch { /* yok */ }
}

/** Kaydedilmiş dönüş adresini bir kez verir ve siler. */
export function takeReturnTo() {
  try {
    const v = sessionStorage.getItem(RETURN_KEY)
    sessionStorage.removeItem(RETURN_KEY)
    return v && v.startsWith('/') && !v.startsWith('//') ? v : null
  } catch {
    return null
  }
}
